<template>
	<t-timpex-icon :icon="icon" :color="color" :size="size" />
</template>

<script>
import { cargoCarrierIcon, statuses } from '@/core';
export default {
	name: 'TripIcon',
	props: {
		trip: {
			type: Object,
			default: () => ({})
		},
		size: {
			type: String,
			default: 'md'
		}
	},
	computed: {
		icon() {
			return this.trip && this.trip.cargoCarrier && this.trip.cargoCarrier.iconId ? cargoCarrierIcon.getIcon(this.trip.cargoCarrier.iconId) : 'truck';
		},
		color() {
			return this.trip && this.trip.status ? statuses.color(this.trip.status) : 'neutral';
		}
	},
};
</script>

<style lang="scss" scoped>

</style>